import styled from "styled-components";

export const FilterSection = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 300px;
`;

export const SortDropdown = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  width: 20rem;
`;

export const MainContent = styled.main`
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1.5rem;
`;

export const UpdatesHeader = styled.h2`
  font-size: 1.4rem;
  font-weight: 500;
  color: #495057;
  margin-bottom: 1rem;
`;

export const UpdateList = styled.ul`
  list-style: none;
  padding: 0;
`;

export const UpdateItem = styled.li`
  padding: 1rem;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const UpdateDate = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.3rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
`;

export const UpdateName = styled.p`
  margin: 0;
  line-height: 1.5;
  font-size: 1.3rem;
`;

export const UpdateDescription = styled.p`
  margin: 0;
  line-height: 1.5;
  font-size: 1.2rem;
  color: #6c757d;
`;

export const NothingToShow = styled.div`
  font-size: 1.4rem;
`;
